var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{class:_vm.$style.container,attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"column":"","fill-height":""}},[_c('representation-toolbar'),_c('vtk-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }